import { watchAuditMiddlewareSaga } from "./auditMiddlewareSaga";

console.log("[audit] index.ts: creating saga");

const auditLogsSagas = [watchAuditMiddlewareSaga()];

console.log("[audit] index.ts: saga created, exporting", auditLogsSagas.length, "saga(s)");

export default auditLogsSagas;
